import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        kaisyacd: "",
        shaincd: "",
        shainName: "",
        api_token: "",
        target_date: "",
        inventoryData: {},
        inventoryMode: "",
        tenpoCd: "",
        tenpoName: "",
        version: "",
        code1: null,
        type1: {"label": "全て", "value": -1},
        code2: null,
        type2: {"label": "全て", "value": -1},
        filterUpdate: false,
        filterRegister: false,
        dataUpdate: [],
        changeItemUpdate: false,
        dataInsert: [],
        changeItemInsert: false
    },
    mutations: {
        updateUser(state, user) {
            state.kaisyacd = user.kaisyacd;
            state.shaincd = user.shaincd;
            state.shainName = user.shainName;
            state.api_token = user.api_token;
        },
        updateTargetTenpo(state, tenpo) {
            state.tenpoCd = tenpo.tenpoCd;
            state.tenpoName = tenpo.tenpoName;
        },
        updateInventoryData(state, inventory) {
            state.target_date = inventory.date;
            state.inventoryMode = inventory.mode;
            state.inventoryData = inventory.inputData;
        },
        updateAPIVersion(state, api) {
            state.version = api.version;
        },
        updateFilter(state, filter) {
            state.code1 = filter.code1;
            state.type1 = filter.type1;
            state.code2 = filter.code2;
            state.type2 = filter.type2;
        },
        updateFilterRegister(state, status) {
            state.filterRegister = status; 
        },
        updateFilterUpdate(state, status) {
            state.filterUpdate = status;
        },
        updateDataUpdate(state, data) {
            state.dataUpdate = data;
        },
        updateDataInsert(state, data) {
            state.dataInsert = data;
        },
        changeItemUpdate(state, status) {
            state.changeItemUpdate = status;
        },
        changeItemInsert(state, status) {
            state.changeItemInsert = status;
        }
    },
    actions: {
        auth(context, user) {
            context.commit('updateUser', user);
        },
        tenpo(context, tenpo) {
            context.commit('updateTargetTenpo', tenpo);
        },
        storeData(context, inventory) {
            context.commit('updateInventoryData', inventory);
        },
        apiData(context, api) {
            context.commit('updateAPIVersion', api);
        },
        filterData(context, filter) {
            context.commit('updateFilter', filter);
        },
        storeFilterStatusRegister(context, data) {
            context.commit('updateFilterRegister', data);
        },
        storeFilterStatusUpdate(context, data) {
            context.commit('updateFilterUpdate', data);
        },
        storeDataUpdate(context, data) {
            context.commit('updateDataUpdate', data);
        },
        storeDataInsert(context, data) {
            context.commit('updateDataInsert', data);
        },
        storeChangeItemUpdate(context, status) {
            context.commit('changeItemUpdate', status);
        },
        storeChangeItemInsert(context, status) {
            context.commit('changeItemInsert', status);
        }
    },
    modules: {},
    plugins: [createPersistedState({
        key: "InventoryProject",
        storage: localStorage
    })]
});

export default store;